import { FilterOption } from '../../../components/_WMS/FilterComponent/types'

export const filterOptions: FilterOption[] = [
  {
    key: 'name',
    label: 'Código',
    type: 'text',
    order: 1
  },
  {
    key: 'active',
    label: 'Activo',
    type: 'precreated',
    order: 2
  }
]
